import { render, staticRenderFns } from "./DetailsPlan.vue?vue&type=template&id=84663080"
import script from "./DetailsPlan.vue?vue&type=script&lang=js"
export * from "./DetailsPlan.vue?vue&type=script&lang=js"
import style0 from "./DetailsPlan.vue?vue&type=style&index=0&id=84663080&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports